<span *ngIf="status && label" class="status-badge ministry-status-badge ministry-status-badge--{{ status | lowercase }}">
  {{ label }}
</span>
